import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Notice } from '@features/dashboard/components/noticeboard/types';

interface NoticeboardState {
  notices: Notice[];
  isLoading: boolean;
  error: string | null;
}

const initialState: NoticeboardState = {
  notices: [],
  isLoading: false,
  error: null
};

export const noticeboardSlice = createSlice({
  name: 'noticeboard',
  initialState,
  reducers: {
    setNotices: (state, action: PayloadAction<Notice[]>) => {
      state.notices = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    addNotice: (state, action: PayloadAction<Notice>) => {
      state.notices.unshift(action.payload);
    },
    updateNotice: (state, action: PayloadAction<Notice>) => {
      const index = state.notices.findIndex(
        (notice) => notice.id === action.payload.id
      );
      if (index !== -1) {
        state.notices[index] = action.payload;
      }
    },
    deleteNotice: (state, action: PayloadAction<string>) => {
      state.notices = state.notices.filter(
        (notice) => notice.id !== action.payload
      );
    }
  }
});

export const {
  setNotices,
  setLoading,
  setError,
  addNotice,
  updateNotice,
  deleteNotice
} = noticeboardSlice.actions;

export default noticeboardSlice.reducer;
